import React, { useState, useEffect } from 'react'
import { useSearchParams} from "react-router-dom";

import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import DeleteNotification from '../../core/components/DeleteNotification';
import {CoreContext} from "../../core/context/CoreContext";
import PageWaiting from '../../core/components/PageWaiting';
import {isMobile} from 'react-device-detect';

import {getListAPI, deleteAPI} from './AssetsAPI';
import {getColumns} from './AssetsStruct';
import ListCardView from '../../core/components/card/ListCardView';
import ListTableView from '../../core/components/card/ListTableView';

import {getAssetsView} from './AssetsView';
import CardListLayout from '../../core/components/card/layout/CardListLayout';
import { useSelector, useDispatch } from 'react-redux';
import {setViewParams} from '../../store/slice/ChoiceSelectionSlice';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

import {setFilter} from '../../store/slice/ConfSlice';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import MyPageContainer from '../../core/template/MyPageContainer';
import { deleteAssetsObj  ,setSelectedAssetsId,setSelectedActionId , setShowEditForAssets} from 'store/slice/ManufSlice';

import AssetsListTable from './components/AssetsListTable';
import { useNavigate } from "react-router-dom";
import { setClickedBo,setActionClicked } from 'store/slice/BreadCrumSlice';
import AssetsFilterCriteria from './AssetsFilterCriteria';
import {  setMfproductLinkAssetModal } from 'store/slice/ManufSlice';


export default function AssetsListImpl( {tableList, cardList, setShowEdit, setAssetsId}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setNotification, setShowLoading, showloading, lastURL } = React.useContext(CoreContext);
  const columns = getColumns(editCallBack, initDeleteCallBack);
  const [view, setView] = useState(1);
  const { showfilter } = useSelector((state) => state.confslice);
  const {mobileView} = useSelector((state) => state.menu);

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const {selectedId, assetsObj} = useSelector((state)=>state.manufslice.assetsDashboard);
  const { assetsList } = useSelector((state) => state.manufslice.assetsDashboard);

  useEffect(() => {
  }, [assetsList, assetsObj])
  
  function initDeleteCallBack(id){
    dispatch(setSelectedAssetsId(id));
    setShowDeleteAlert(true);
  }
  function deleteCallBack(obj){
    dispatch(deleteAssetsObj(obj.id));
    setNotification('Record deleted successfully !!!')
  }
  function deleteRecord(){
    deleteAPI(selectedId,deleteCallBack);
    setShowDeleteAlert(false);
  }

  function editCallBack(id){
    dispatch(setSelectedAssetsId(id));
    dispatch(setShowEditForAssets(true));
  }
  
  const createAssets=()=>{
    dispatch(setSelectedAssetsId(-1));
    //dispatch(setShowEditForAssets(true));
    dispatch(setMfproductLinkAssetModal(true));
  }



const getDataWithDateTransformation = (data) =>{
    let newData = {
      ...data,
      'expand':false,

    }
    return newData;
  }
  const assetsTransformation = (tableList) =>{
    let newDataList=[]
    tableList.map((data)=>{ 
      newDataList.push(getDataWithDateTransformation(data));
     })
    return newDataList;
  }

  const payload = {
    assetsList:assetsList,
    cardList:getAssetsView(tableList),
        actionList: [
          /*{title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
          {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
          
        */
        ],
        dialogueActionList: [
          
        ],
    tableView:{
      tableList:assetsTransformation(tableList),
      assetsList:assetsList,
      actionList:[
        {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
        {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
        
      ]
    }
  }
  
  const getPayload = ()=>{
    return payload;
  }

  useEffect(()=>{
    if (document.body.offsetWidth<500)  setView(0);
    dispatch(setViewParams({
      colsCount:{xs:12, sm:4, md:4, lg:4},
      modal:{
            
      }
      }))
  },[])

  return (
   <>
   {showloading?<PageWaiting/>:
      <Grid container direction="column">
              <Grid item>
                  <Grid container direction="row" justifyContent={'space-between'} alignContent={'center'} sx={{ width: '100%',}}>
                      <Grid item  lg={8}>
                        <Typography variant='h4' color="primary.darker">Assets Linked to Products</Typography>
                      </Grid>
                      
                      <Grid item lg={4}>
                        <Grid container justifyContent={'flex-end'}>
                        
                            <Grid item>
                              <Tooltip title="Add Assets" sx={{cursor: "pointer"}}>
                                {!mobileView ?
                                <button
                                  onClick={createAssets}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    background: '#1976d2',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 4,
                                    padding: '6px 16px',
                                    fontWeight: 500,
                                    fontSize: 16,
                                    cursor: 'pointer'
                                  }}
                                >
                                  <AddIcon sx={{ fontSize: 22 }} />
                                  Link Asset(s)
                                </button>
                                :<AddIcon sx={{ fontSize: 22 }} onClick={createAssets} />}
                              </Tooltip>
                            </Grid>
                          </Grid>
                      </Grid>
                      
                  </Grid>
              </Grid>
              <Grid item>
                < AssetsListTable 
                  payload={getPayload().tableView}
                  />
                  
              </Grid>     
      </Grid>
   }
    { showDeleteAlert?<DeleteNotification 
            id={selectedId}
            width="50%"
            setShowDeleteAlert={setShowDeleteAlert}
            deleteRecord = {deleteRecord}/>: ''
    }

    
    </>
);


}